import _ from 'lodash';
import Api from '@/api';
import * as types from '../mutation-types';

const state = {
  // 基本配置
  shop_name: '',
  site_url: '',
  static_url: '',
  help_mail: '',
  copyright: '',
  icp: '',
  phone: '',
  whats_app: '',
  company_address: '',
  company_address_lat: '',
  company_address_lng: '',
  shop_default_category_id: null,
  store_keyword: '',
  index_new_arrival_limit: 8,
  index_recommend_limit: 8,
  index_hot_limit: 8,
  index_sale_limit: 8,
  per_page: 9,
  invitation_registration_integral: 0,
  website_search_suggests: '',

  // 分銷配置
  distribution_default_brokerage_lv1: 0,
  distribution_default_order_discount_lv1: 0,
  distribution_default_brokerage_lv2: 0,
  distribution_default_order_discount_lv2: 0,
  distribution_upgrade_need_order_total_lv2: 0,
  distribution_default_brokerage_lv3: 0,
  distribution_default_order_discount_lv3: 0,
  distribution_upgrade_need_order_total_lv3: 0,
  distribution_default_brokerage_lv4: 0,
  distribution_default_order_discount_lv4: 0,
  distribution_upgrade_need_order_total_lv4: 0,
  distribution_default_brokerage_lv5: 0,
  distribution_default_order_discount_lv5: 0,
  distribution_upgrade_need_order_total_lv5: 0,
  need_captcha: [],
};

const getters = {
  getConfigByKey: s => key => _.get(s, key),
};

const actions = {
  fetchConfigs({ commit }) {
    return Api.config.get().then(({ data: response }) => {
      commit(types.RECEIVE_CONFIGS, response);
    });
  },
};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_CONFIGS](s, response) {
    _.forEach(response, (value, key) => {
      s[key] = value;
    });
  },
  [types.RECEIVE_SETTINGS](s, response) {
    response.data.forEach((item) => {
      const num = Number(item.value);
      s[item.key] = _.isNaN(num) ? item.value : num;
      s.settings[item.key] = _.isNaN(num) ? item.value : num;
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
